// Copyright (c) 2023 WiseTime. All rights reserved.

import { EMPTY, interval, mergeMap, Observable, of } from "rxjs"
import { Action } from "redux"
import { filter, withLatestFrom } from "rxjs/operators"
import * as Actions from "../actions"
import * as TimelineSlice from "../slices/timeline"
import { toTimelineDate } from "../dateTime"
import { DateTime } from "luxon"
import { RootState } from "../../../app/store"

export const syncCurrentDay = () =>
  (action$: Observable<Action>, state$: Observable<RootState>): Observable<Action> =>
    action$.pipe(
      filter(Actions.syncCurrentDay.match),
      withLatestFrom(state$),
      mergeMap(([, state]) =>
        interval(60000).pipe(
          mergeMap((_) => {
            const actualDay = toTimelineDate(DateTime.local())
            if (state.timeline.currentDay !== actualDay) {
              return of(TimelineSlice.setCurrentDay(actualDay))
            } else {
              return EMPTY
            }
          })
        ),
      )
    )

export default syncCurrentDay()
